(() => {
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const route = path => ROOT + path.replace(/^\//, '');

  const money = cents => {
    const amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      }).format(amount);
    } catch (_) {
      return '$' + amount.toFixed(2);
    }
  };

  const escapeHTML = value => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  async function addLines(items) {
    const response = await fetch(route('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items })
    });

    let result = {};
    try { result = await response.json(); } catch (_) {}
    if (!response.ok) {
      throw new Error(result.description || result.message || 'Unable to add this item to cart.');
    }
    return result;
  }

  function selectedVariant(root) {
    return root.querySelector('[name="deko_variant"]:checked');
  }

  function selectedPack(root) {
    return root.querySelector('[name="deko_pack"]:checked');
  }

  function getSourceVariants(root) {
    return [...root.querySelectorAll('[name="deko_variant"]')];
  }

  function getVariantData(root) {
    return getSourceVariants(root).map(input => ({
      id: String(input.value),
      title: input.closest('.dpv2-option')?.querySelector('.dpv2-option-copy b')?.textContent?.trim() || 'Option',
      price: Number(input.dataset.price || 0),
      compare: Number(input.dataset.compare || 0),
      available: input.dataset.available !== 'false' && !input.disabled,
      image: input.dataset.image || root.querySelector('.dpv2-gallery-hero')?.src || '',
      thumb: input.dataset.thumb || input.dataset.image || root.querySelector('.dpv2-gallery-hero')?.src || ''
    }));
  }

  function ensureBundleStyles() {
    if (document.getElementById('dpv2-bundle-variant-styles')) return;
    const style = document.createElement('style');
    style.id = 'dpv2-bundle-variant-styles';
    style.textContent = `
      .dpv2-section-head[hidden],.dpv2-options[data-dpv2-source-hidden="true"]{display:none!important}
      .dpv2-bundle-variants{display:none;margin:-1px 0 9px;padding:13px;border:2px solid #111;border-top:0;background:#fbfaf8}
      .dpv2-bundle-variants.is-visible{display:block}
      .dpv2-bundle-variants__title{display:flex;justify-content:space-between;gap:12px;align-items:center;margin:0 0 10px;font-size:10px;font-weight:900;letter-spacing:.06em}
      .dpv2-bundle-variants__title span{font-size:9px;font-weight:400;letter-spacing:0;color:#6b6b6b}
      .dpv2-bundle-unit{padding:10px 0;border-top:1px solid #dedbd7}
      .dpv2-bundle-unit:first-of-type{border-top:0;padding-top:0}
      .dpv2-bundle-unit__label{display:block;margin:0 0 7px;font-size:9px;font-weight:900;letter-spacing:.08em;color:#4f4f4f}
      .dpv2-mini-options{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:7px}
      .dpv2-mini-option{position:relative;display:grid;grid-template-columns:38px minmax(0,1fr);gap:8px;align-items:center;min-height:52px;padding:6px 8px;border:1px solid #d8d5d1;background:#fff;cursor:pointer}
      .dpv2-mini-option.is-selected{border:2px solid #111;padding:5px 7px}
      .dpv2-mini-option.is-unavailable{opacity:.45;cursor:not-allowed}
      .dpv2-mini-option input{position:absolute;opacity:0;pointer-events:none}
      .dpv2-mini-option img{width:36px;height:36px;object-fit:cover;background:#f4f1ed}
      .dpv2-mini-option b{font-size:10px;line-height:1.15;overflow-wrap:anywhere}
      .dpv2-mini-option small{display:block;margin-top:2px;font-size:8px;color:#a02b22}
      @media(max-width:749px){
        .dpv2-bundle-variants{padding:10px}
        .dpv2-mini-options{grid-template-columns:1fr 1fr;gap:6px}
        .dpv2-mini-option{grid-template-columns:34px minmax(0,1fr);padding:5px 6px;min-height:48px}
        .dpv2-mini-option.is-selected{padding:4px 5px}
        .dpv2-mini-option img{width:32px;height:32px}
        .dpv2-mini-option b{font-size:9px}
      }
    `;
    document.head.appendChild(style);
  }

  function hideSourceVariantSelector(root) {
    const head = root.querySelector('.dpv2-section-head');
    const options = root.querySelector('.dpv2-options');
    if (head) head.hidden = true;
    if (options) {
      options.hidden = true;
      options.dataset.dpv2SourceHidden = 'true';
      options.setAttribute('aria-hidden', 'true');
    }
  }

  function createBundlePanel(root, row, quantity, variants, defaultVariantId) {
    const panel = document.createElement('div');
    panel.className = 'dpv2-bundle-variants';
    panel.dataset.bundleVariantPanel = String(quantity);
    panel.innerHTML = quantity === 1
      ? '<div class="dpv2-bundle-variants__title">CHOOSE YOUR OPTION <span>Select your preferred style</span></div>'
      : '<div class="dpv2-bundle-variants__title">CHOOSE EACH ITEM <span>Mix & match variants</span></div>';

    for (let unit = 1; unit <= quantity; unit += 1) {
      const unitWrap = document.createElement('div');
      unitWrap.className = 'dpv2-bundle-unit';
      if (quantity > 1) {
        const unitLabel = document.createElement('span');
        unitLabel.className = 'dpv2-bundle-unit__label';
        unitLabel.textContent = `ITEM ${unit}`;
        unitWrap.appendChild(unitLabel);
      }

      const options = document.createElement('div');
      options.className = 'dpv2-mini-options';
      options.setAttribute('role', 'radiogroup');
      options.setAttribute('aria-label', quantity === 1 ? 'Choose product option' : `Choose option for item ${unit}`);

      variants.forEach(variant => {
        const label = document.createElement('label');
        label.className = `dpv2-mini-option${variant.id === defaultVariantId ? ' is-selected' : ''}${variant.available ? '' : ' is-unavailable'}`;

        const input = document.createElement('input');
        input.type = 'radio';
        input.name = `deko_bundle_variant_${quantity}_${unit}`;
        input.value = variant.id;
        input.dataset.price = String(variant.price);
        input.dataset.available = String(variant.available);
        input.dataset.image = variant.image;
        input.dataset.thumb = variant.thumb || variant.image;
        input.dataset.bundleVariant = 'true';
        if (variant.id === defaultVariantId && variant.available) input.checked = true;
        if (!variant.available) input.disabled = true;

        if (!variants.some(v => v.id === defaultVariantId && v.available)) {
          const firstAvailable = variants.find(v => v.available);
          if (firstAvailable && firstAvailable.id === variant.id) input.checked = true;
        }

        label.appendChild(input);
        if (variant.thumb || variant.image) {
          const img = document.createElement('img');
          img.src = variant.thumb || variant.image;
          img.alt = variant.title;
          img.loading = 'lazy';
          label.appendChild(img);
        }

        const copy = document.createElement('span');
        copy.innerHTML = `<b>${escapeHTML(variant.title)}</b>${variant.available ? '' : '<small>Sold out</small>'}`;
        label.appendChild(copy);
        options.appendChild(label);
      });

      unitWrap.appendChild(options);
      panel.appendChild(unitWrap);
    }

    row.insertAdjacentElement('afterend', panel);
    return panel;
  }

  function ensureBundleVariantPanels(root) {
    if (root.dataset.dpv2BundlePanels === 'true') return;
    const variants = getVariantData(root);

    if (variants.length <= 1) {
      root.dataset.dpv2BundlePanels = 'true';
      return;
    }

    const defaultVariantId = selectedVariant(root)?.value || variants.find(v => v.available)?.id || variants[0]?.id;
    [1, 2, 3].forEach(quantity => {
      const packInput = root.querySelector(`[name="deko_pack"][value="${quantity}"]`);
      const row = packInput?.closest('[data-dpv2-bundle]');
      if (row && !root.querySelector(`[data-bundle-variant-panel="${quantity}"]`)) {
        createBundlePanel(root, row, quantity, variants, defaultVariantId);
      }
    });

    hideSourceVariantSelector(root);
    root.dataset.dpv2BundlePanels = 'true';
  }

  function selectedBundleVariants(root, quantity) {
    const sourceVariants = getSourceVariants(root);

    if (sourceVariants.length === 1) {
      return Array.from({ length: quantity }, () => sourceVariants[0]);
    }

    const nested = [...root.querySelectorAll(
      `[data-bundle-variant-panel="${quantity}"] [data-bundle-variant]:checked`
    )];

    if (nested.length) return nested;

    if (quantity === 1) {
      const variant = selectedVariant(root);
      return variant ? [variant] : [];
    }

    return [];
  }

  function aggregateItems(inputs) {
    const quantities = new Map();
    inputs.forEach(input => {
      const id = String(input.value);
      quantities.set(id, (quantities.get(id) || 0) + 1);
    });
    return [...quantities.entries()].map(([id, quantity]) => ({ id: Number(id), quantity }));
  }

  function updateNestedSelection(root) {
    root.querySelectorAll('.dpv2-mini-option').forEach(card => {
      card.classList.toggle('is-selected', !!card.querySelector('[data-bundle-variant]:checked'));
    });
  }

  function updatePanels(root, quantity) {
    root.querySelectorAll('[data-bundle-variant-panel]').forEach(panel => {
      panel.classList.toggle('is-visible', Number(panel.dataset.bundleVariantPanel) === quantity);
    });
  }

  function syncSourceVariantFromBuyOne(root, nestedInput) {
    const panel = nestedInput.closest('[data-bundle-variant-panel]');
    if (Number(panel?.dataset.bundleVariantPanel || 0) !== 1) return;

    const source = getSourceVariants(root).find(input => String(input.value) === String(nestedInput.value));
    if (source && !source.disabled) source.checked = true;
  }

  function syncBundlePanelsFromSource(root, sourceInput) {
    const selectedId = String(sourceInput.value);
    root.querySelectorAll('[data-bundle-variant-panel] .dpv2-bundle-unit').forEach(unit => {
      const matching = [...unit.querySelectorAll('[data-bundle-variant]')]
        .find(input => String(input.value) === selectedId);
      if (matching && !matching.disabled) matching.checked = true;
    });
  }

  function bundleTotalFor(root, row, fallbackPrice) {
    const radio = row.querySelector('[name="deko_pack"]');
    const rowQty = Number(radio?.value || 1);
    const rowDiscount = Number(radio?.dataset.discount || 0);
    const selected = selectedBundleVariants(root, rowQty);
    let original = fallbackPrice * rowQty;

    if (selected.length === rowQty) {
      original = selected.reduce((sum, input) => sum + Number(input.dataset.price || fallbackPrice), 0);
    }

    return {
      original,
      total: Math.round(original * (100 - rowDiscount) / 100)
    };
  }

  function updateProduct(root) {
    const form = root.querySelector('#DekoConversionProductForm');
    if (!form) return;

    ensureBundleVariantPanels(root);

    const variant = selectedVariant(root);
    const pack = selectedPack(root);
    if (!variant || !pack) return;

    const price = Number(variant.dataset.price || 0);
    const compare = Number(variant.dataset.compare || 0);
    const quantity = Number(pack.value || 1);
    const discount = Number(pack.dataset.discount || 0);

    root.querySelectorAll('.dpv2-option').forEach(card => {
      card.classList.toggle('is-selected', !!card.querySelector('[name="deko_variant"]:checked'));
    });
    root.querySelectorAll('[data-dpv2-bundle]').forEach(row => {
      row.classList.toggle('is-selected', !!row.querySelector('[name="deko_pack"]:checked'));
    });
    updateNestedSelection(root);
    updatePanels(root, quantity);

    const currentPrice = root.querySelector('[data-dpv2-current-price]');
    const comparePrice = root.querySelector('[data-dpv2-compare]');
    const save = root.querySelector('[data-dpv2-save]');
    if (currentPrice) currentPrice.textContent = money(price);

    if (comparePrice && save) {
      if (compare > price) {
        comparePrice.hidden = false;
        comparePrice.textContent = money(compare);
        save.hidden = false;
        save.textContent = 'SAVE ' + Math.round((1 - price / compare) * 100) + '%';
      } else {
        comparePrice.hidden = true;
        save.hidden = true;
      }
    }

    const chosen = selectedBundleVariants(root, quantity);
    const sourceVariantsForAvailability = getSourceVariants(root);
    const singleVariantFallback = sourceVariantsForAvailability.length === 1
      && chosen.length === quantity
      && chosen.every(input => Boolean(input.value));
    const bundleReady = singleVariantFallback || (
      chosen.length === quantity && chosen.every(input => (
        input.dataset.available !== 'false' && !input.disabled
      ))
    );

    const stock = root.querySelector('[data-dpv2-stock]');
    const stockText = root.querySelector('[data-dpv2-stock-text]');
    if (stock) stock.classList.toggle('is-soldout', !bundleReady);
    if (stockText) stockText.textContent = bundleReady ? 'In stock — ready to ship' : 'Sold out or unavailable';

    root.querySelectorAll('[data-dpv2-bundle]').forEach(row => {
      const totals = bundleTotalFor(root, row, price);
      const totalEl = row.querySelector('[data-dpv2-bundle-total]');
      const originalEl = row.querySelector('[data-dpv2-bundle-original]');
      if (totalEl) totalEl.textContent = money(totals.total);
      if (originalEl) originalEl.textContent = money(totals.original);
    });

    const hiddenVariant = form.querySelector('[data-dpv2-form-variant]');
    const hiddenQuantity = form.querySelector('[data-dpv2-form-quantity]');
    if (hiddenVariant) hiddenVariant.value = variant.value;
    if (hiddenQuantity) hiddenQuantity.value = String(quantity);

    const hero = root.querySelector('.dpv2-gallery-hero');
    if (hero && variant.dataset.image && quantity === 1) {
      hero.src = variant.dataset.image;
      hero.srcset = '';
    }

    const add = root.querySelector('[data-dpv2-add]');
    const buy = root.querySelector('[data-dpv2-buy]');
    if (add) {
      add.disabled = !bundleReady;
      add.textContent = bundleReady
        ? `ADD ${quantity} TO CART${discount ? ` — SAVE ${discount}%` : ''} →`
        : 'SELECT AVAILABLE OPTIONS';
    }
    if (buy) {
      buy.disabled = !bundleReady;
      buy.textContent = bundleReady ? 'BUY NOW — SECURE CHECKOUT' : 'SELECT AVAILABLE OPTIONS';
    }
  }

  function init(root) {
    if (!root || root.dataset.dpv2Ready === 'true') return;
    root.dataset.dpv2Ready = 'true';
    ensureBundleStyles();
    ensureBundleVariantPanels(root);

    root.addEventListener('change', event => {
      if (!event.target.matches('[name="deko_variant"], [name="deko_pack"], [data-bundle-variant]')) return;

      if (event.target.matches('[name="deko_variant"]')) {
        syncBundlePanelsFromSource(root, event.target);
      }

      if (event.target.matches('[data-bundle-variant]')) {
        syncSourceVariantFromBuyOne(root, event.target);
        if (event.target.dataset.image) {
          const hero = root.querySelector('.dpv2-gallery-hero');
          if (hero) {
            hero.src = event.target.dataset.image;
            hero.srcset = '';
          }
        }
      }

      updateProduct(root);
    });

    root.querySelectorAll('[data-dpv2-thumb]').forEach(button => {
      button.addEventListener('click', () => {
        const hero = root.querySelector('.dpv2-gallery-hero');
        if (hero && button.dataset.image) {
          hero.src = button.dataset.image;
          hero.srcset = '';
        }
        root.querySelectorAll('[data-dpv2-thumb]').forEach(item => item.classList.remove('is-active'));
        button.classList.add('is-active');
      });
    });

    updateProduct(root);
  }

  document.querySelectorAll('[data-dpv2-product]').forEach(init);

})();
